import { Callout, ICalloutProps } from 'components/layout/Callout';
import { ActionLinks } from 'components/ActionLinks/ActionLinks';
import { IActionLinkItem } from 'components/ActionLinks/ActionLinkModels';
import { DebounceComponent } from 'components/DebounceComponent';

export interface IContextMenuProps extends Pick<ICalloutProps, 'isOpen' | 'onClose' | 'placement' | 'sourceRef'> {
  isLoading: boolean;
  actions: IActionLinkItem[];
}

/**
 * This component should be replaced with common context menu component as soon as Sam merges its changes to master
 *
 * Copyright (c) 2022 Decisions All Rights Reserved
 */
export function ContextMenu({ isOpen, onClose, placement, sourceRef, isLoading, actions }: IContextMenuProps) {
  if (!isOpen)
    return null;

  // we use DebounceComponent here to prevent callout jumping when "Loading" is shown initially and after that "ActionLinks" are shown
  // and request executed very quickly, so we don't need to show "Loading" at all.
  return (
    <DebounceComponent>
      <Callout
        className="tt-context-menu"
        isOpen={isOpen}
        onClose={onClose}
        sourceRef={sourceRef}
        placement={placement}
        showArrow={true}
        flipBehavior="flip"
      >
        {isLoading && <div className="tt-context-menu__loading">Loading actions...</div>}
        {!isLoading && (
          <ActionLinks values={{ current: actions }} />
        )}
      </Callout>
    </DebounceComponent>
  );
};
